module.exports = __webpack_public_path__ + "img/turkey-water-schema.c517565f.png";